module.exports = __webpack_public_path__ + "static/key-thebard-704e577142a4dfb4206dca766e900149.webp";